{
  "adobeExperienceCloudNoOrgsSelect": "选择其他组织帐户",
  "adobeExperienceCloudSelectedOrg": "所选组织：{org}",
  "appSwitcherLinkOutIconLabel": "在新窗口中打开",
  "feedback button default": "反馈",
  "help": "帮助",
  "launchsidebar": "启动侧边栏",
  "more actions": "更多操作",
  "searchButton": "搜索",
  "solutionSwitcher": "切换至其他解决方案",
  "solutionSwitcherList": "应用程序列表",
  "solutionSwitcherPopover": "应用程序列表弹出框"
}
